import React from "react";
import { FaRocket, FaShoppingCart, FaUniversity, FaBalanceScale, FaHospitalAlt, FaHome } from "react-icons/fa";

const useCases = [
  {
    icon: <FaRocket className="text-3xl text-blue-400" />,
    title: "Startups & SMBs",
    description:
      "Scale without the security headaches. Tokenize sensitive business data from day one—contracts, employee info, internal systems—and stay compliant without slowing down.",
    bullets: [
      "Enterprise-grade protection",
      "Reduce IT overhead",
      "Stay audit-ready",
      "Build customer trust",
    ],
  },
  {
    icon: <FaShoppingCart className="text-3xl text-pink-400" />,
    title: "E-commerce",
    description:
      "Protect customer addresses and order info with tokenization—so even if there's a breach, your data stays unreadable.",
    bullets: ["GDPR-ready", "Protects from fraud", "Promotes customer confidence"],
  },
  {
    icon: <FaUniversity className="text-3xl text-green-400" />,
    title: "Financial Services",
    description:
      "Whether it’s GDPR, CCPA, or local mandates, JustWhere.io keeps you compliant while reducing risk and complexity.",
    bullets: ["Lower IT costs", "Simplify audits", "Minimize breach risk"],
  },
  {
    icon: <FaBalanceScale className="text-3xl text-yellow-400" />,
    title: "Legal Teams",
    description:
      "Keep sensitive legal documents secure and accessible only to authorized parties.",
    bullets: ["Ensure confidentiality", "Reduce exposure", "Simplify compliance workflows"],
  },
  {
    icon: <FaHospitalAlt className="text-3xl text-red-400" />,
    title: "Healthcare Providers",
    description:
      "Tokenize medical records and documents to maintain HIPAA compliance and uphold trust.",
    bullets: ["HIPAA-compliant", "Reduce breach risks", "Maintain privacy standards"],
  },
  {
    icon: <FaHome className="text-3xl text-indigo-400" />,
    title: "Real Estate",
    description:
      "From client details to signed deals, ensure data privacy across your entire real estate lifecycle.",
    bullets: ["Protect deal documents", "Minimize legal exposure", "Strengthen brand trust"],
  },
];

export default function UseCasesPage() {
  return (
    <div className="text-gray-100 min-h-screen py-4 px-4 md:px-10">

      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3 max-w-7xl mx-auto">
        {useCases.map((item, idx) => (
          <div
            key={idx}
            className="bg-gray-800 rounded-xl shadow-md p-6 hover:shadow-xl transition border border-gray-700"
          >
            <div className="mb-2">{item.icon}</div>
            <h2 className="text-xl font-semibold mb-2 text-white">
              {item.title}
            </h2>
            <p className="mb-4 text-gray-300">{item.description}</p>
            <ul className="list-disc list-inside text-green-300 space-y-1">
              {item.bullets.map((bullet, i) => (
                <li key={i}>{bullet}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
}
